"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnvironmentService = void 0;
const tsyringe_1 = require("tsyringe");
const required_1 = require("../../../../helpers/required/required");
const environment_1 = require("../../../../environment/environment");
const lodash_1 = require("lodash");
const isNodeOrBrowser_helper_1 = require("../../../../helpers/isNodeOrBrowser.helper");
let EnvironmentService = class EnvironmentService {
    constructor() {
        this.swithEnv = (env) => {
            required_1.requiredDefined(environment_1.environment[env], `this env ${env} does not exist`);
            this.environment = environment_1.environment[env];
            return this.environment;
        };
        this.setEnv = (env) => {
            this.environment = env;
            return this.environment;
        };
        this.setProvider = (provider) => {
            this.environment.defaultProvider = provider;
            return this.environment;
        };
        this.setEnvFromProcessEnvOrWindow();
    }
    setEnvFromProcessEnvOrWindow() {
        let environment;
        if (isNodeOrBrowser_helper_1.isBrowser) {
            environment = lodash_1.get(window, 'spkzEnv');
        }
        else if (isNodeOrBrowser_helper_1.isNode) {
            environment = lodash_1.get(process, 'env.spkzEnv');
        }
        if (environment) {
            required_1.requiredDefined(environment_1.environment[environment], `this env ${environment} does not exist`);
            console.info(`environment is set from process.env to ${environment}`);
            this.environment = environment_1.environment[environment];
        }
        else {
            this.environment = environment_1.environment.prod;
        }
    }
};
EnvironmentService = __decorate([
    tsyringe_1.scoped(tsyringe_1.Lifecycle.ContainerScoped),
    __metadata("design:paramtypes", [])
], EnvironmentService);
exports.EnvironmentService = EnvironmentService;
;
/**

 chain config pour les strategies

 env pour les rooms et bouncer

 **/
//# sourceMappingURL=environementService.js.map